<template>
  <div class="absolute top-4 right-4 z-10">
    <UButton
      v-if="showFavoriteButton"
      :aria-label="t('a11y.favorite-button')"
      v-bind="
        isFavorite
          ? {
              variant: 'solid',
              color: 'error',
              icon: 'i-heroicons-heart-20-solid',
            }
          : { variant: 'subtle', color: 'neutral', icon: 'i-heroicons-heart' }
      "
      size="md"
      @click="handleFavoriteButton()"
    />
  </div>

  <AuthModal v-model="modalIsOpen">
    <template #default>
      <CottageBookmarks
        :item="item"
        @submit-success="closeModal"
      ></CottageBookmarks>
    </template>
  </AuthModal>
</template>

<script setup lang="ts">
import fetchBookmarkDelete from '~~/modules/api/rurality/v3/bookmarks/delete'
import { useUserStore } from '~~/modules/auth/stores/userStore'
import { sendConnectifSaveFavoriteEvent } from '~~/modules/integrations/connectif/composables/useConnectifComposable'

const userStore = useUserStore()

const modalIsOpen = ref(false)
const showFavoriteButton = ref<boolean>(false)
const isFavorite = ref<boolean>(false)

const user = userStore.getUserdata

type itemType = {
  id: string
  name: string
  province: {
    slug: string
    name: string
    url: string
  }
  village: {
    slug: string
    name: string
  }
  media: Array<{
    url: string
    type: 'PHOTO' | 'VIDEO'
    alt: string
    width: number | null
    height: number | null
  }>
}

interface propsInterface {
  item: itemType
}

const props = defineProps<propsInterface>()

const closeModal = async () => {
  modalIsOpen.value = false
}

const handleFavoriteButton = async () => {
  if (isFavorite.value) {
    const data = await fetchBookmarkDelete({
      cottageUid: props.item.id,
    })
    if (data.success) {
      isFavorite.value = false
    }
  } else {
    modalIsOpen.value = true
    sendConnectifSaveFavoriteEvent()
  }
}

const init = async () => {
  if (!user.logged) {
    showFavoriteButton.value = true
  } else if (user.logged && user.params?.cottage_bookmarks) {
    showFavoriteButton.value = true
    const cottageBookmarks = userStore.params?.cottage_bookmarks || []
    isFavorite.value = cottageBookmarks.some(
      (bookmark: { cottageId: string }) => bookmark.cottageId === props.item.id,
    )
  }
}

const unsubscribe = userStore.$subscribe(() => {
  init()
})
onUnmounted(() => {
  unsubscribe()
})

watchEffect(() => {
  const cottageBookmarks = userStore.params?.cottage_bookmarks || []
  isFavorite.value = cottageBookmarks.some(
    (bookmark: { cottageId: string }) => bookmark.cottageId === props.item.id,
  )
})

onMounted(() => {
  init()
})
</script>
